import {Injectable} from '@angular/core';
import {Http, RequestOptionsArgs, RequestOptions, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {AppConstants} from '../../app.constants';
import {MarkaModel} from '../../model/spring-model/marka.model';

export interface Header {
  header: string;
  value: string;
}

@Injectable()
export class ImageService {

  constructor(private http: HttpClient) {
  }

  public postImage(url: string, image: File, headers?: Header[], partName: string = 'image', withCredentials?: boolean) {
    if (!url || url === '') {
      throw new Error('Url is not set! Please set it before doing queries');
    }
    const formData: FormData = new FormData();
    formData.append(partName, image);
    return this.http.post(url, formData, {observe: 'response'});
  }
}





// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/ng2-image-upload/image-upload/image.service.ts